(function() { window.GUID_ec713583_f124_4ce2_876a_c4078d0f5773 = { getGuid: function() { return "ec713583-f124-4ce2-876a-c4078d0f5773"; } }; })();
var lastFlowBlockId;
var btnScoreSheet = $('#BtnScoreSheet');
function BindBracketEvents(canvasContentEdge) {
    if (lastFlowBlockId != actualFlowBlockId) {
        ClearAllOpenedMenus();
    }
    lastFlowBlockId = actualFlowBlockId;
    var busyIndicator = $('#BusyIndicator');
    var roundHeaders = $('#RoundHeaders');
    bracketBoxes = $('.BB', canvasContentEdge);
    RebindAlreadySelectedElement(canvasContentEdge);
    CS.Views.ByesHelper.getByesSequence(canvasContentEdge);
    var btnByeSequence = $('#BtnByeSequence');
    btnByeSequence.on('click', 'a', function (e) {
        e.preventDefault();
        CS.Views.ByesHelper.ShowAllSpotsWithOrder(canvasContentEdge);
    });
    canvasContentEdge.off('StartDragging');
    canvasContentEdge.on('StartDragging', function () {
        ClearAllOpenedMenus();
    });
    canvasContentEdge.off('Zooming');
    canvasContentEdge.on('Zooming', function () {
        ClearAllOpenedMenus();
    });
    canvasContentEdge.off('CanvasClick');
    canvasContentEdge.off('Moving');
    canvasContentEdge.on('CanvasClick', function (e, canvasEvent) {
        if (busyIndicator.is(':visible')) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        var target = $(canvasEvent.target);
        var targetParent = target.parent();
        if (target.closest('#BracketBoxControls').length > 0 ||
            target[0].id == "ScheduleBoxBtnOptionsMenu" ||
            targetParent[0].id == "EncounterOptionsMenu" ||
            target[0].id == "LooserDivisionId" ||
            target[0].id == "WinnerDivisionId") {
            return;
        }
        ClearAllOpenedMenus();
        var bbParent = target.parents('.BB');
        if (bbParent.length > 0) {
            e.preventDefault();
            OnBracketBoxClicked(canvasEvent, bbParent);
        }
        else if (target.hasClass('SB') || target.hasClass('ST') || target.hasClass('SS') || target.hasClass('SC') || target.hasClass('EN')) {
            e.preventDefault();
            OnScheduleBoxClicked(canvasEvent, target);
        }
        else {
            SetBtnScoreSheetEnabled(null);
            ResetHighlightDrawBoxes(lastHighlight, null, function () {
                RefreshToolBarButtons();
            });
        }
    });
    BindBracketMainOptionsMenu(canvasContentEdge, actualFlowBlockId);
    BindBracketHeaderMenu(canvasContentEdge, actualFlowBlockId);
    BindBtnScoreSheet_click();
    //Pour enabler les fleches apres le load
    $('.CSZoomCanvasHiddenText').focus();
}
function ClearAllOpenedMenus() {
    $('#EncounterOptionsMenu').remove();
    $('#BracketHeaderMenu').remove();
    $('#BracketMainOptionsMenu').remove();
}
function RebindAlreadySelectedElement(canvasContentEdge) {
    var alreadySelectedElement = $('.SEL', canvasContentEdge);
    if (alreadySelectedElement.length > 0) {
        if (alreadySelectedElement.hasClass('BB')) {
            lastHighlight.DrawBoxFocus = alreadySelectedElement;
            GetEncounterInfoOfBracket(actualFlowBlockId, null, ParseDrawPosition(lastHighlight.DrawBoxFocus[0].id, true), false, function (encounterInfos) {
                actualEncounterInfos = encounterInfos;
            });
        }
        else {
            lastHighlight.ScheduleBoxFocus = alreadySelectedElement;
            GetEncounterInfoOfBracket(actualFlowBlockId, null, ParseEncounterNumber(lastHighlight.ScheduleBoxFocus[0].id, true), false, function (encounterInfos) {
                actualEncounterInfos = encounterInfos;
            });
        }
    }
    var elemntsOfSamePath = $('.Hgl', canvasContentEdge);
    lastHighlight.EntityPath = elemntsOfSamePath;
}
function OnBracketBoxClicked(e, element) {
    var clientX = e.clientX;
    var clickedBox = $(element);
    var pastMidScreen = (CS.win.width() / 2) < e.clientX;
    ResetHighlightDrawBoxes(lastHighlight, pastMidScreen, function (mousePosition) {
        GetEntityPopup(null, ParseDrawPosition(clickedBox[0].id, true), pastMidScreen, function (encounterInfos) {
            actualEncounterInfos = encounterInfos;
            SetHighlightDrawBoxes(encounterInfos, zoomCanvas.CanvasContentEdge, function (result) {
                lastHighlight = result;
            });
            SetBtnScoreSheetEnabled(encounterInfos);
        });
    });
}
function OnScheduleBoxClicked(e, clickedElement) {
    var scheduleBox = null;
    if (clickedElement.hasClass('SB')) {
        scheduleBox = clickedElement;
    }
    else if (clickedElement.hasClass('SC')) {
        scheduleBox = clickedElement.parent();
    }
    else if (clickedElement.hasClass('ST') || clickedElement.hasClass('SS') || clickedElement.hasClass('EN')) {
        scheduleBox = clickedElement.parent().parent();
    }
    var data = null;
    ResetHighlightDrawBoxes(lastHighlight, data, function () {
        GetEncounterInfoOfBracket(actualFlowBlockId, ParseEncounterNumber(scheduleBox[0].id, true), null, false, function (encounterInfos) {
            actualEncounterInfos = encounterInfos;
            SetBtnScoreSheetEnabled(encounterInfos);
            SetHighlightDrawBoxes(encounterInfos, zoomCanvas.CanvasContentEdge, function (result) {
                lastHighlight = result;
            });
            if (e.which == 3 && CSParameters.IsSportEventAdminSlashManage) {
                GetSchedulePopup();
            }
        });
    });
}
function NavigateToOtherChart(flowBlockId, drawPosition, entityId) {
    var data = {};
    data.flowBlockId = flowBlockId;
    data.isBracket = true;
    data.highlightedEntityBaseId = entityId;
    data.highlightedDrawPosition = drawPosition;
    data.refreshDropDown = true;
    CompuSport.Ajax.Get(CSParameters.RUrl + "charts/chart/" + CSParameters.SportEventId, data, function (result) {
        UpdateChart(result, false);
    });
}
function BindBtnScoreSheet_click() {
    btnScoreSheet.on('click', 'a', function (e) {
        e.preventDefault();
        ShowScorePopup();
    });
}
function SetBtnScoreSheetEnabled(encounterInfos) {
    if (encounterInfos == null) {
        btnScoreSheet.addClass('IsDisabled');
        return;
    }
    var hasTwoOpponents = encounterInfos.OppName0 != null && encounterInfos.OppName0 != "" && encounterInfos.OppName1 != null && encounterInfos.OppName1 != "";
    if (hasTwoOpponents && !encounterInfos.IsFakeEncounter) {
        btnScoreSheet.removeClass('IsDisabled');
    }
    else {
        btnScoreSheet.addClass('IsDisabled');
    }
}

//# sourceMappingURL=Brackets.desktop.js.map
